export default __webpack_public_path__ + "static/media/ZoneTypeE.5f9e75fd.png";